import store from '../../store/store'
import locale from '@packs/locale/locale'
import colors from '../../helpers/colors'
import ChartModal from '@components/modal/chart_modal/chart_modal'
import map_helper from '@packs/components/map/helpers/map_helper'
import AvgHistOpt from './components/avg_hist_opt'
import MonthAcum from './components/month_acum'

export default function PopUpComponent(opts={}){
    BaseConstructor.call(this)
    let {container,chartModal} = opts
    let elements = {}
    let context = this

    let popup = L.popup() //popup para infos no mapa

    this.show = (latLng, data, map) =>{
        popup.setLatLng(latLng).setContent(_=>setContent(data,latLng)).openOn(map)
    }

    this.update = () =>{

    }

    const setContent = (data,latLng) =>{
        if(data.type == 'station_flu' || data.type == 'station_plu'){
            return getStationContent(data)
        } else {
            //context menu
            let content = context.createElement('div', 'leaflet-context-wrapper', generateContextContent(latLng))
            return content
        }
    }

    const generateContextContent = latLng =>{
      let avgHistOpt = new AvgHistOpt({latLng:latLng})
      let container = context.createElement('div')
      let el_latlng = context.createElement('div', 'list-opt-container', `${map_helper.ConvertDDToDMS(latLng.lat, false)}, ${map_helper.ConvertDDToDMS(latLng.lng, true)}`)
      let el_gethist = context.createElement('div', '', avgHistOpt.getElement())
      $(container).append(el_latlng, el_gethist)
      return container
    }

    const getStationContent = data =>{
      
        if(data.type==='station_flu'){
          let TYPE = store.mainConfigStore.getType()
          let status = data.obj.status || data.obj.marker.options.icon.options.status
          let pt_status = locale.t(status)
          //container do popup content
          let el = document.createElement('div')
          $(el).addClass('popup-container')
          //estrutura popup
          
          $(el).append("<div class='popup-station-info-wrapper list-opt-container'><div class='popup-title-wrapper'><div class='popup-title'>"+(data.obj.station_name || data.obj.station.name)+"</div>"+
          `<div class='font-weight-bold'><span class="text-muted font-size-md">${data.obj.prefix}</span>`+
          `${TYPE === 'flu' ? `<span class="font-size-sm badge badge-dark ml-2" style="background-color:${colors[status]};color:white">${pt_status[0].toUpperCase() + pt_status.substring(1,pt_status.length)}</span>` : ''}</div></div>`+
          `<div title='Município'><i class="fas fa-map-marker-alt"></i> ${(data.obj.city || data.obj.station.city.name)}</div>`+
          `<div class='mt-1'><i class="fas fa-copy"></i> ${(data.obj.latitude || data.obj.station.latitude)},${(data.obj.longitude || data.obj.station.longitude)}</div>`+
          `<div title='Proprietário'><i class="fas fa-user"></i> ${(data.obj.station_owner || data.obj.station_owner.name)}</div>`+
          '</div>'
          )
      

          if(TYPE === 'plu'){
            //acumulado do mês
            let monthAcum = new MonthAcum({station:data.obj})
            let month_el = context.createElement('div', 'list-opt-container')
            $(month_el).append(monthAcum.getElement())
            $(el).append(month_el)

            //média historica componente em caso de plu
            // let avgHistOpt = new AvgHistOpt({latLng:{lat: (data.obj.latitude || data.obj.station.latitude), lng: (data.obj.longitude || data.obj.station.longitude)}})
            // let mh_container = context.createElement('div', '')
            // $(mh_container).html(avgHistOpt.getElement())
            // $(el).append(mh_container)
            
          }
          
      
      
          //botão 'modal gráficos' no popup
          let button = document.createElement('button')
          $(button).addClass('btn-open-chart')
          button.type = 'button'
          button.innerText = 'Gráficos'
          $(button).on('click', () =>{
            store.modalConfigStore.setStationIds([data.obj.id || data.obj.station_prefix_id]) //on click
          })
      
          
          //gráfico de nível caso flu
          if(TYPE === 'flu'){
            let chart_container = document.createElement('div')
            $(chart_container).addClass('popup-chart-container')
            $(el).append(chart_container)
            setTimeout(_=>{
              generateSmallChart(chart_container, data.obj)
            },100)
          }
          
          
      
          $(el).append(button)
      
          return el
        } else {
          return "<div>content</div>"
        }
    }

    function generateSmallChart(chart_container, obj){      

      let valueHandle = value =>{
        return value/100
      }
      //só como helper para o método
      let plotlines = chartModal.generateReferenceValuesPlotlines([obj.parameter] || [], valueHandle)
    
      let chart = Highcharts.chart(chart_container, {
    
        yAxis: {
            title: {
                text: 'Nível'
            }
        },
        title:{
          text: ''
        },
        xAxis: {
          type: 'datetime',
          crosshair: true,
        },
        tooltip: {
          shared: true,
          formatter: function (e) {
              let html = '<b>' + moment(this.x).format("YYYY-MM-DD HH:mm") + '</b><br>'
              $.each(this.points, function(index, point){
                html += '<b><span style="color:'+ point.color +'">' + point.y +` m</span></b><br/>`;
              })
              return html
          },
      },
        yAxis:[{
            title: {
                text: 'Nível'
            },
            labels: {
                format: '{value} m'
            },
            plotLines: plotlines
        }],
        plotOptions: {
            series: {
                label: {
                    connectorAllowed: false
                }
            }
        },
    
        series: [{name: 'Nível', data:obj.measurements.map(x=>[moment(x.date, 'YYYY-MM-DD HH:mm').subtract(3, 'hours').valueOf(), parseFloat((x.value/100).toFixed(3))])}],
    
      });

      chartModal.setChartLimits(chart, plotlines, obj.measurements,valueHandle)

    }
      

    
}

PopUpComponent.prototype = Object.create(BaseConstructor.prototype)